import React, { useEffect, useState } from 'react'
import { FaGlobe } from 'react-icons/fa'
import { WebsiteLinkFormProps } from '../../../types/onboardingTypes'
import { NextButton, BackButton } from '../shared/Buttons'
import { Theme } from '../../../lib/theme';
const WebsiteLinkForm: React.FC<WebsiteLinkFormProps> = ({
  onContinue,
  onBack,
  initialData,
  isNextLoading,
}) => {
  const [websiteLink, setWebsiteLink] = useState(initialData)
  const [isValidLink, setIsValidLink] = useState(false)

  useEffect(() => {
    setWebsiteLink(initialData)
    validateLink(initialData) // Validate initial data if provided
  }, [initialData])

  const validateLink = (link: string | undefined) => {
    if (!link) {
      setIsValidLink(false)
      return
    }
    // Regular expression to validate a URL
    const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/
    setIsValidLink(urlRegex.test(link))
  }

  const handleInputFocus = () => {
    if (!websiteLink) {
      setWebsiteLink('https://') // Pre-fill "https://" if empty
    }
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const updatedValue = e.target.value

    if (updatedValue === '') {
      setWebsiteLink('')
      validateLink('')
      return
    }

    setWebsiteLink(updatedValue)
    validateLink(updatedValue)
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    onContinue({ websiteLink }) // Allows an empty or filled website link
  }

  return (
<div
  className="lg:p-0 p-2 w-full mt-[4rem] xl:mt-[2rem] 2xl:mt-[3rem] md:h-[90%] md:w-[80%] md:shadow-lg md:rounded-3xl md:flex md:flex-col md:items-center md:justify-between md:p-4"
  style={{ backgroundColor: Theme.colors.background }}
>
  {/* Heading Section */}
  <div className="flex flex-col items-center gap-1 p-2 lg:p-0">
    <FaGlobe
      className="text-6xl lg:text-4xl xl:text-6xl mb-2"
      style={{ color: Theme.colors.primary }}
    />
    <h1
      className="text-2xl font-bold mb-1"
      style={{ color: Theme.colors.text.strong }}
    >
      Website Link
    </h1>
    <p style={{ color: Theme.colors.text.weak }}>
      Provide your website link
    </p>
  </div>

  {/* Input Section */}
  <form
    onSubmit={handleSubmit}
    className="w-full max-w-sm mx-auto flex-grow flex flex-col justify-center"
  >
    <div className="w-full">
      <label
        htmlFor="websiteLink"
        className="mb-3 font-semibold block text-left"
        style={{ color: Theme.colors.text.default }}
      >
        Website Link
      </label>
      <input
        type="text"
        id="websiteLink"
        placeholder="Enter website link"
        className="mb-7 w-full rounded-xl border outline-none"
        style={{
          padding: '1rem',
          borderColor: Theme.colors.stroke.weak,
          color: Theme.colors.text.default,
          backgroundColor: Theme.colors.background,
          caretColor: Theme.colors.primary,
        }}
        value={websiteLink}
        onChange={handleInputChange}
        onFocus={handleInputFocus}
      />
      {!isValidLink && websiteLink && (
        <p className="text-sm mt-2" style={{ color: Theme.colors.error }}>
          Please enter a valid website link.
        </p>
      )}
    </div>
  </form>

  {/* Buttons */}
  <div className="lg:w-[40%] flex flex-col items-center p-2 mt-auto lg:pb-20 gap-2">
    {isNextLoading ? (
      <div
        className="w-10 h-10 border-4 rounded-full animate-spin"
        style={{
          borderColor: Theme.colors.stroke.weak,
          borderTopColor: Theme.colors.button.primary,
        }}
      ></div>
    ) : websiteLink.length > 0 ? (
      <NextButton
        text={'Continue'}
        disabled={!isValidLink}
        onClick={handleSubmit}
      />
    ) : (
      <NextButton
        text={'Skip'}
        onClick={() => onContinue({ websiteLink: '' })}
      />
    )}
    <BackButton onClick={onBack} />
  </div>
</div>

  )
}

export default WebsiteLinkForm
